import { LlmForkService } from '@adaptiva/ai/common';
import { IconComponent } from '@adaptiva/widgets/icon';
import { ChangeDetectionStrategy, Component, computed, inject, Signal } from '@angular/core';

@Component({
	imports: [IconComponent],
	selector: '[ada-llm-chat-footer]',
	templateUrl: './llm-chat-footer.component.html',
	styleUrl: './llm-chat-footer.component.scss',
	changeDetection: ChangeDetectionStrategy.OnPush,
	host: {
		'[class.ada-border]': 'true',
		'[class.ada-font-weight-bold]': 'true',
	}
})
export class LlmChatFooter {

	protected readonly forkService: LlmForkService = inject(LlmForkService);

	protected readonly forkName: Signal<string> = computed(() => {
		return this.forkService.activeFork()?.forkName ?? 'Unknown';
	});

}
